document.addEventListener("DOMContentLoaded", () => {
    AFRAME.registerComponent("kinematic-body", {
        dependencies: ["velocity"],
        schema: {
            mass: { default: 85 },
            radius: { default: 1.3 },
            linearDamping: { default: 0.05 },
            enableSlopes: { default: false },
            enableJumps: { default: false },
            friction: { default: -1 },
            fly: { default: false },
        },
        init() {
            this.system = this.el.sceneEl.systems.physics;
            this.system.addComponent(this);
            const element = this.el;
            const data = this.data;
            const position = new CANNON.Vec3().copy(
                element.object3D.getWorldPosition(new THREE.Vector3())
            );

            this.body = new CANNON.Body({
                material: this.system.getMaterial("staticMaterial"),
                position: position,
                mass: data.mass,
                linearDamping: data.linearDamping,
                fixedRotation: true,
                allowSleep: false,
                collisionFilterGroup: 1,
                collisionFilterMask: 3,
            });

            this.body.addShape(
                new CANNON.Sphere(data.radius),
                new CANNON.Vec3(0, data.radius + 0.025, 0)
            );

            this.body.updateBoundingRadius();

            if (element.sceneEl.systems.physics.debug) {
                const mesh = CANNON.shape2mesh(this.body);
                element.object3D.add(mesh);
            }

            this.body.el = element;
            this.system.addBody(this.body, 1);
            element.hasAttribute("wasd-controls");
        },
        remove() {
            this.system.removeBody(this.body);
            this.system.removeComponent(this);
            delete this.el.body;
        },
        beforeStep(time, delta) {
            if (!delta) return;
            const element = this.el;
            const data = this.data;
            const body = this.body;

            if (data.fly) body.velocity.set(0, 0, 0);

            body.position.copy(element.object3D.position);
            body.quaternion.copy(element.object3D.quaternion);
            body.velocity.y = Math.max(body.velocity.y, -8);
        },
        step(time, delta) {
            if (!delta) return;
            const body = this.body;
            this.el.object3D.position.copy(body.position);
        },
        afterStep(time, delta) {},
    });
});
